import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, ReactReduxContext } from 'react-redux';
import { addLocaleData } from 'react-intl';
import toastr from 'toastr';
import localeEn from 'react-intl/locale-data/en';
import localeTr from 'react-intl/locale-data/tr';
import store, { history } from './redux/store';

import App from './App';
//  css
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import '../node_modules/toastr/toastr.scss';
import './table.css';

addLocaleData([...localeEn, ...localeTr]);
toastr.options = { positionClass: 'toast-bottom-right', progressBar: true };

ReactDOM.render(
  <Provider store={store} context={ReactReduxContext}>
    <App history={history} context={ReactReduxContext} />
  </Provider>,
  document.getElementById('root'),
);
